import React from 'react';
import '../../../../stylesheets/stylesLayout/tableViews.scss';
import BookingsFiltersBar from './BookingsFiltersBar';
import { useBookingList } from '../../../contextsProperty/ContextBookings';
import BookingStatisticsSection from '../bookingStatistics/BookingStatisticsSection';
import { BookingListViewType } from '../../../../types/booking/bookingListTypes';
import BookingsTable from './tableView/BookingsTable';
import BookingCalendar from './calendarView/BookingCalendar';

const BookingListView = () => {
    const { visibleView } = useBookingList();

    return (
        <div className='bookings__container gap-10'>
            {visibleView === BookingListViewType.STATISTICS ? (
                <BookingStatisticsSection />
            ) : (
                <>
                    <BookingsFiltersBar />
                    {visibleView === BookingListViewType.TABLE ? (
                        <BookingsTable />
                    ) : (
                        <BookingCalendar />
                    )}
                </>
            )}
        </div>
    );
};

export default BookingListView;
